import { InventoryItem } from '../types/models';
import { format } from 'date-fns';

export function exportItemsToCSV(items: InventoryItem[]): void {
  const header = 'Item Name,Item Group,Item ID,Status,Checked Out To,Last Updated';
  const rows = items.map(item => {
    const name = escapeCsvField(item.itemName);
    const group = escapeCsvField(item.itemGroup || '');
    const id = escapeCsvField(item.itemID);
    const status = item.checkedOut ? 'Checked Out' : 'Available';
    const checkedOutTo = escapeCsvField(item.checkedOutTo || '');
    const lastUpdated = item.lastUpdated
      ? format(new Date(item.lastUpdated * 1000), 'yyyy-MM-dd HH:mm:ss')
      : '';
    return `${name},${group},${id},${status},${checkedOutTo},${lastUpdated}`;
  });

  const csv = [header, ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `inventory-export-${format(new Date(), 'yyyy-MM-dd')}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}

export interface ParsedItem {
  itemName: string;
  itemGroup: string;
}

export function parseCSVToItems(csvText: string): ParsedItem[] {
  const lines = csvText.trim().split('\n');
  if (lines.length < 2) return [];

  // Parse header to find column indexes
  const header = parseCSVLine(lines[0]).map(h => h.toLowerCase().trim());
  const nameIdx = header.findIndex(h => h.includes('name'));
  const groupIdx = header.findIndex(h => h.includes('group'));

  if (nameIdx === -1) return [];

  const items: ParsedItem[] = [];
  for (let i = 1; i < lines.length; i++) {
    const cols = parseCSVLine(lines[i]);
    const name = cols[nameIdx]?.trim();
    if (!name) continue;

    items.push({
      itemName: name,
      itemGroup: groupIdx >= 0 ? (cols[groupIdx]?.trim() || '') : '',
    });
  }

  return items;
}

// Parse a single CSV line handling quoted fields
function parseCSVLine(line: string): string[] {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    if (inQuotes) {
      if (char === '"' && line[i + 1] === '"') {
        current += '"';
        i++;
      } else if (char === '"') {
        inQuotes = false;
      } else {
        current += char;
      }
    } else {
      if (char === '"') {
        inQuotes = true;
      } else if (char === ',') {
        result.push(current);
        current = '';
      } else {
        current += char;
      }
    }
  }
  result.push(current);
  return result;
}

function escapeCsvField(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}
